/**
 * Csv Schema of ConfigAlerta
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ConfigAlerta} from '@/model/resource/ConfigAlerta'

/* TODO: review generated schema */
export class CsvConfigAlertaSchema extends Schema {
  readonly name = 'CsvConfigAlerta'

  readonly fieldSet: FieldSet<ConfigAlerta> = {
    idConfigAlertaPk: schema => schema.model.idConfigAlertaPk,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
